import { jsx as d, jsxs as X } from "react/jsx-runtime";
import m, { createContext as H, useContext as G, useState as p, useMemo as $, useCallback as w, useEffect as V } from "react";
import { TextField as _, FormattedTextField as k, Select as K, SecuredTextField as j, SecuredInputField as Z } from "@one-snap/sparkles";
import { InputAdornment as E, IconButton as q, FormControl as z, InputLabel as J, MenuItem as Q } from "@mui/material";
import { Visibility as ee, VisibilityOff as te } from "@mui/icons-material";
import { useDebounce as re, useEffectDeferred as se } from "@one-snap/core";
import { isEmpty as W, Objects as ne } from "@one-snap/toolbox";
var oe = (e) => e.type === "checkbox", ae = (e) => e instanceof Date, T = (e) => e == null;
const ue = (e) => typeof e == "object";
var v = (e) => !T(e) && !Array.isArray(e) && ue(e) && !ae(e), le = (e) => v(e) && e.target ? oe(e.target) ? e.target.checked : e.target.value : e, ie = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, ce = (e, r) => e.has(ie(r)), de = (e) => {
  const r = e.constructor && e.constructor.prototype;
  return v(r) && r.hasOwnProperty("isPrototypeOf");
}, fe = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function S(e) {
  let r;
  const t = Array.isArray(e);
  if (e instanceof Date)
    r = new Date(e);
  else if (e instanceof Set)
    r = new Set(e);
  else if (!(fe && (e instanceof Blob || e instanceof FileList)) && (t || v(e)))
    if (r = t ? [] : {}, !t && !de(e))
      r = e;
    else
      for (const s in e)
        e.hasOwnProperty(s) && (r[s] = S(e[s]));
  else
    return e;
  return r;
}
var D = (e) => Array.isArray(e) ? e.filter(Boolean) : [], C = (e) => e === void 0, h = (e, r, t) => {
  if (!r || !v(e))
    return t;
  const s = D(r.split(/[,[\].]+?/)).reduce((o, n) => T(o) ? o : o[n], e);
  return C(s) || s === e ? C(e[r]) ? t : e[r] : s;
};
const B = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, M = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, me = m.createContext(null), O = () => m.useContext(me);
var he = (e, r, t, s = !0) => {
  const o = {
    defaultValues: r._defaultValues
  };
  for (const n in e)
    Object.defineProperty(o, n, {
      get: () => {
        const a = n;
        return r._proxyFormState[a] !== M.all && (r._proxyFormState[a] = !s || M.all), t && (t[a] = !0), e[a];
      }
    });
  return o;
}, ye = (e) => v(e) && !Object.keys(e).length, pe = (e, r, t, s) => {
  t(e);
  const { name: o, ...n } = e;
  return ye(n) || Object.keys(n).length >= Object.keys(r).length || Object.keys(n).find((a) => r[a] === !s);
}, be = (e) => Array.isArray(e) ? e : [e], I = (e, r, t) => t && r ? e === r : !e || !r || e === r || be(e).some((s) => s && (s.startsWith(r) || r.startsWith(s)));
function N(e) {
  const r = m.useRef(e);
  r.current = e, m.useEffect(() => {
    const t = !e.disabled && r.current.subject && r.current.subject.subscribe({
      next: r.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
function ge(e) {
  const r = O(), { control: t = r.control, disabled: s, name: o, exact: n } = e || {}, [a, u] = m.useState(t._formState), l = m.useRef(!0), i = m.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), c = m.useRef(o);
  return c.current = o, N({
    disabled: s,
    next: (f) => l.current && I(c.current, f.name, n) && pe(f, i.current, t._updateFormState) && u({
      ...t._formState,
      ...f
    }),
    subject: t._subjects.state
  }), m.useEffect(() => (l.current = !0, i.current.isValid && t._updateValid(!0), () => {
    l.current = !1;
  }), [t]), he(a, t, i.current, !1);
}
var Fe = (e) => typeof e == "string", ve = (e, r, t, s, o) => Fe(e) ? h(t, e, o) : Array.isArray(e) ? e.map((n) => h(t, n)) : t;
function b(e) {
  const r = O(), { control: t = r.control, name: s, defaultValue: o, disabled: n, exact: a } = e || {}, u = m.useRef(s);
  u.current = s, N({
    disabled: n,
    subject: t._subjects.values,
    next: (c) => {
      I(u.current, c.name, a) && i(S(ve(u.current, t._names, c.values || t._formValues, !1, o)));
    }
  });
  const [l, i] = m.useState(t._getWatch(s, o));
  return m.useEffect(() => t._removeUnmounted()), l;
}
var xe = (e) => /^\w*$/.test(e), Ce = (e) => D(e.replace(/["|']|\]/g, "").split(/\.|\[/));
function P(e, r, t) {
  let s = -1;
  const o = xe(r) ? [r] : Ce(r), n = o.length, a = n - 1;
  for (; ++s < n; ) {
    const u = o[s];
    let l = t;
    if (s !== a) {
      const i = e[u];
      l = v(i) || Array.isArray(i) ? i : isNaN(+o[s + 1]) ? {} : [];
    }
    e[u] = l, e = e[u];
  }
  return e;
}
function _e(e) {
  const r = O(), { name: t, control: s = r.control, shouldUnregister: o } = e, n = ce(s._names.array, t), a = b({
    control: s,
    name: t,
    defaultValue: h(s._formValues, t, h(s._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = ge({
    control: s,
    name: t
  }), l = m.useRef(s.register(t, {
    ...e.rules,
    value: a
  }));
  return l.current = s.register(t, e.rules), m.useEffect(() => {
    const i = s._options.shouldUnregister || o, c = (f, g) => {
      const x = h(s._fields, f);
      x && (x._f.mount = g);
    };
    if (c(t, !0), i) {
      const f = S(h(s._options.defaultValues, t));
      P(s._defaultValues, t, f), C(h(s._formValues, t)) && P(s._formValues, t, f);
    }
    return () => {
      (n ? i && !s._state.action : i) ? s.unregister(t) : c(t, !1);
    };
  }, [t, s, n, o]), {
    field: {
      name: t,
      value: a,
      onChange: m.useCallback((i) => l.current.onChange({
        target: {
          value: le(i),
          name: t
        },
        type: B.CHANGE
      }), [t]),
      onBlur: m.useCallback(() => l.current.onBlur({
        target: {
          value: h(s._formValues, t),
          name: t
        },
        type: B.BLUR
      }), [t, s]),
      ref: (i) => {
        const c = h(s._fields, t);
        c && i && (c._f.ref = {
          focus: () => i.focus(),
          select: () => i.select(),
          setCustomValidity: (f) => i.setCustomValidity(f),
          reportValidity: () => i.reportValidity()
        });
      }
    },
    formState: u,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!h(u.errors, t)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!h(u.dirtyFields, t)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!h(u.touchedFields, t)
      },
      error: {
        enumerable: !0,
        get: () => h(u.errors, t)
      }
    })
  };
}
const L = (e) => e, Y = H({
  getErrorMessage: L
}), We = ({
  children: e,
  getErrorMessage: r = L
}) => /* @__PURE__ */ d(Y.Provider, { value: { getErrorMessage: r }, children: e });
function ke(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var R = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var r = {}.hasOwnProperty;
    function t() {
      for (var s = [], o = 0; o < arguments.length; o++) {
        var n = arguments[o];
        if (n) {
          var a = typeof n;
          if (a === "string" || a === "number")
            s.push(n);
          else if (Array.isArray(n)) {
            if (n.length) {
              var u = t.apply(null, n);
              u && s.push(u);
            }
          } else if (a === "object")
            if (n.toString === Object.prototype.toString)
              for (var l in n)
                r.call(n, l) && n[l] && s.push(l);
            else
              s.push(n.toString());
        }
      }
      return s.join(" ");
    }
    e.exports ? (t.default = t, e.exports = t) : window.classNames = t;
  })();
})(R);
var Se = R.exports;
const A = /* @__PURE__ */ ke(Se), y = ({
  name: e,
  control: r,
  render: t,
  errorMessageValues: s,
  className: o,
  errorClassName: n
}) => {
  const {
    field: a,
    fieldState: { invalid: u, error: l }
  } = _e({ name: e, control: r }), { getErrorMessage: i } = G(Y), c = u && (l != null && l.message) ? i(l == null ? void 0 : l.message, s) : "";
  return /* @__PURE__ */ X(
    "div",
    {
      className: A("inline-flex flex-col mb-5 relative", o),
      "aria-errormessage": "errorMsg",
      "aria-live": "polite",
      children: [
        t(a, u, c),
        l ? /* @__PURE__ */ d(
          "div",
          {
            className: A(
              "secondaryFont text-SnapError px-4 pt-2",
              n
            ),
            "data-testid": "field-control-error",
            id: "errorMsg",
            children: c
          }
        ) : null
      ]
    }
  );
}, Te = ({
  control: e,
  name: r,
  label: t,
  className: s,
  errorMessageValues: o,
  ...n
}) => {
  const a = b({ control: e, name: r }), [u, l] = p(!1);
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      errorMessageValues: o,
      className: s,
      render: (i, c) => /* @__PURE__ */ d(
        _,
        {
          ...i,
          fullWidth: !0,
          label: t,
          error: c,
          "data-testid": n["data-testid"],
          ...n,
          focused: !!a || u,
          onFocus: () => {
            l(!0);
          },
          onBlur: () => {
            i.onBlur(), l(!1);
          }
        }
      )
    }
  );
}, De = ({
  control: e,
  name: r,
  label: t,
  errorMessageValues: s,
  className: o,
  ...n
}, a) => {
  const [u, l] = p(!1);
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      className: o,
      errorMessageValues: s,
      render: (i, c) => /* @__PURE__ */ d(
        _,
        {
          ...i,
          fullWidth: !0,
          label: t,
          error: c,
          "data-testid": n["data-testid"],
          ...n,
          ref: a,
          type: u ? "text" : "password",
          InputProps: {
            endAdornment: /* @__PURE__ */ d(E, { position: "end", children: /* @__PURE__ */ d(
              q,
              {
                "aria-label": "toggle password visibility",
                onClick: () => {
                  l(!u);
                },
                children: u ? /* @__PURE__ */ d(ee, {}) : /* @__PURE__ */ d(te, {})
              }
            ) })
          }
        }
      )
    }
  );
}, Ie = ({
  control: e,
  name: r,
  label: t,
  errorMessageValues: s,
  className: o,
  format: n = "(000) 000-0000",
  ...a
}) => {
  const u = b({ control: e, name: r }), [l, i] = p(!1);
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      className: o,
      errorMessageValues: s,
      render: (c, f) => /* @__PURE__ */ d(
        k,
        {
          ...c,
          fullWidth: !0,
          label: t,
          error: f,
          mask: n,
          maskedValue: !1,
          ...a,
          focused: l,
          InputLabelProps: u && { shrink: !0 },
          onFocus: () => {
            i(!0);
          },
          onBlur: () => {
            c.onBlur(), i(!1);
          },
          type: "tel"
        }
      )
    }
  );
}, Ne = ({
  control: e,
  name: r,
  label: t,
  options: s,
  className: o,
  errorMessageValues: n,
  ...a
}) => /* @__PURE__ */ d(
  y,
  {
    name: r,
    control: e,
    className: o,
    errorMessageValues: n,
    render: (u, l) => (
      // ToDo: FormControl is only needed bc we are using material stuff
      // we need to move away from material in general
      /* @__PURE__ */ X(z, { className: "block", children: [
        /* @__PURE__ */ d(J, { children: t }),
        /* @__PURE__ */ d(
          K,
          {
            ...u,
            fullWidth: !0,
            label: t,
            error: l,
            ...a,
            inputProps: {
              "aria-label": t
            },
            children: s.map((i) => /* @__PURE__ */ d(Q, { value: i.value, children: i.title }, i.value))
          }
        )
      ] })
    )
  }
), Le = ({
  control: e,
  name: r,
  label: t,
  className: s,
  errorMessageValues: o,
  maskedValue: n = !1,
  ...a
}) => {
  const u = b({ control: e, name: r }), [l, i] = p(!1), c = "000-00-0000";
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      errorMessageValues: o,
      className: s,
      render: (f, g) => /* @__PURE__ */ d(
        j,
        {
          ...f,
          ...a,
          fullWidth: !0,
          label: t,
          error: g,
          visibleValueMask: c,
          definitionMask: "0",
          mask: n ? "XXX-XX-XXXX" : c,
          maskedValue: n,
          inputProps: {
            maxLength: 9,
            "data-testid": a["data-testid"]
          },
          focused: !!u || l,
          onFocus: () => {
            i(!0);
          },
          onBlur: () => {
            f.onBlur(), i(!1);
          }
        }
      )
    }
  );
}, Ye = ({
  control: e,
  name: r,
  label: t,
  errorMessageValues: s,
  format: o = "MM/dd/YYYY",
  maskedValue: n = !1,
  ...a
}) => {
  const u = b({ control: e, name: r }), [l, i] = p(!1), c = Oe[o];
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      errorMessageValues: s,
      render: (f, g) => /* @__PURE__ */ d(
        j,
        {
          ...f,
          ...a,
          fullWidth: !0,
          label: t,
          error: g,
          visibleValueMask: c,
          definitionMask: "0",
          mask: n ? Ve[c] : c,
          maskedValue: n,
          inputProps: {
            "data-testid": a["data-testid"]
          },
          focused: !!u || l,
          onFocus: () => {
            i(!0);
          },
          onBlur: () => {
            f.onBlur(), i(!1);
          }
        }
      )
    }
  );
}, Oe = {
  "MM/dd/YYYY": "00/00/0000",
  "MM/YYYY": "00/0000"
}, Ve = {
  "00/00/0000": "XX/XX/XXXX",
  "00/0000": "XX/XXXX"
}, Re = ({
  control: e,
  name: r,
  label: t,
  errorMessageValues: s,
  className: o,
  ...n
}) => /* @__PURE__ */ d(
  y,
  {
    name: r,
    control: e,
    className: o,
    errorMessageValues: s,
    render: (a, u) => /* @__PURE__ */ d(
      _,
      {
        ...a,
        fullWidth: !0,
        label: t,
        error: u,
        "data-testid": n["data-testid"],
        ...n,
        type: "email"
      }
    )
  }
), Be = (e) => e < 4 ? "000".slice(0, e) : "X".repeat(e - 2) + "00", Ue = ({
  control: e,
  name: r,
  label: t,
  className: s,
  errorMessageValues: o,
  maskedValue: n = !1,
  isPrefilled: a,
  ...u
}) => {
  const l = b({ control: e, name: r }) || "", [i, c] = p(!1), f = "00000000000000000", g = $(() => n ? Be(l.length) : f, [n, l.length]);
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      errorMessageValues: o,
      className: s,
      render: (x, U) => /* @__PURE__ */ d(
        Z,
        {
          ...x,
          ...u,
          fullWidth: !0,
          label: t,
          isPrefilled: a,
          error: U,
          visibleValueMask: f,
          definitionMask: "0",
          "data-testid": u["data-testid"],
          mask: g,
          maskedValue: n,
          value: l,
          inputProps: {
            maxLength: 17,
            minLength: 4
          },
          focused: !!l || i,
          onFocus: () => {
            c(!0);
          },
          onBlur: () => {
            x.onBlur(), c(!1);
          }
        }
      )
    }
  );
}, He = ({
  control: e,
  name: r,
  label: t,
  errorMessageValues: s,
  ...o
}) => {
  const n = w(
    (a) => {
      o.onBlur && o.onBlur(a);
    },
    [o.onBlur]
    // Recreate only when props.onBlur changes
  );
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      render: (a, u) => /* @__PURE__ */ d(
        k,
        {
          ...a,
          fullWidth: !0,
          label: t,
          error: u,
          "data-testid": o["data-testid"],
          mask: "000000000",
          maskedValue: !1,
          onBlur: n
        }
      )
    }
  );
}, Ge = ({
  control: e,
  name: r,
  label: t,
  errorMessageValues: s,
  ...o
}) => {
  const n = b({ control: e, name: r }), [a, u] = p(!1);
  return /* @__PURE__ */ d(
    y,
    {
      name: r,
      control: e,
      errorMessageValues: s,
      render: (l, i) => /* @__PURE__ */ d(
        k,
        {
          ...l,
          inputMode: "decimal",
          type: "text",
          mask: "num",
          blocks: {
            num: {
              mask: Number,
              thousandsSeparator: ",",
              radix: ".",
              padFractionalZeros: !1
            }
          },
          ...o,
          focused: !!n || a,
          InputProps: (a || l.value) && {
            startAdornment: /* @__PURE__ */ d(E, { className: "ml-1 -mr-2", position: "start", children: /* @__PURE__ */ d("span", { className: "snap-color-grey-500", children: "$" }) }),
            className: "[&>input]:!pl-0 [&>input]:ml-[24px]"
          },
          onFocus: () => {
            u(!0);
          },
          onBlur: () => {
            l.onBlur(), u(!1);
          },
          fullWidth: !0,
          label: t,
          error: i,
          inputProps: {
            "data-testid": o["data-testid"]
          }
        }
      )
    }
  );
}, $e = ({
  form: e,
  cacheId: r,
  debounceTime: t = 1e3
}) => {
  const [s, o] = p(!1), {
    control: n,
    reset: a,
    formState: { isDirty: u }
  } = e, l = b({ control: n }), i = re(l, t);
  V(() => {
    const c = F.cacheId === r;
    !s && !W(Object.keys(F.values)) && c && (a(F.values), o(!0));
  }, [a, s, r]), V(() => {
    u && (F.cacheId = r, F.values = { ...i });
  }, [r, i, u]);
}, F = {
  cacheId: "",
  values: {}
}, Ke = () => {
  F.cacheId = "", F.values = {};
};
function Ze({ formRef: e, locale: r }) {
  const { getValues: t, trigger: s } = e, o = w(() => {
    const n = ne.getFlattenedObject(t()), a = Object.keys(n).filter(
      (u) => !!n[u]
    );
    W(a) || s(a);
  }, [t, s]);
  se(o, [r, s, t], 1);
}
export {
  Ue as BankAccountTextFieldControl,
  He as BankRoutingTextFieldControl,
  Ge as CurrencyTextFieldControl,
  Ye as DateTextFieldControl,
  Re as EmailFieldControl,
  y as FieldControl,
  Y as FormFieldControlContext,
  We as FormFieldControlProvider,
  De as PasswordFieldControl,
  Ie as PhoneFieldControl,
  Le as SSNTextFieldControl,
  Ne as SelectFieldControl,
  Te as TextFieldControl,
  Ke as resetFormCache,
  $e as useFormCache,
  Ze as useFormLocale
};
